import { render, staticRenderFns } from "./review-form-item.vue?vue&type=template&id=b64eb2f0"
import script from "./review-form-item.vue?vue&type=script&lang=js"
export * from "./review-form-item.vue?vue&type=script&lang=js"
import style0 from "./review-form-item.vue?vue&type=style&index=0&id=b64eb2f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports